export default __webpack_public_path__ + "static/media/aboutIsa_001.a38c42ca.png";